import React from "react";

import styled from 'styled-components';
import ClaroImage from '../ClaroImage'
import { GenericFormContext } from '../../../context/genericFormContext';

const ClaroDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    margin: 0 auto;
    padding: 0rem 0rem 0rem 0rem;
    max-width: 100%;
    align-items: center;
    justify-content: center;
`

const ClaroInputField = styled.input`
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0rem'};
-webkit-appearance: none;
border-radius: 0;
height: ${props => props.height ? props.height : 'auto'};
min-height: ${props => props.height ? props.height : '34px'};
font-family: ${props => props.fontFamily ? props.fontFamily : 'Roboto'};
font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
color: ${props => props.color ? props.color : '#323232'};
font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border-style: ${props => props.borderStyle ? props.borderStyle : 'none'};
background: ${props => props.background ? props.background : 'transparent'};
border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
width: ${props => props.width ? props.width : 'auto'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
outline: ${props => props.outline ? props.outline : 'none'}; 
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
max-width: 100%;
::placeholder {
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    color: ${props => props.phColor ? props.phColor : '#323232'};
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Roboto'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
}
`


const ClaroInputFieldPesos = styled.input`
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0rem'};
-webkit-appearance: none;
border-radius: 0;
height: ${props => props.height ? props.height : 'auto'};
min-height: ${props => props.height ? props.height : '34px'};
font-family: ${props => props.fontFamily ? props.fontFamily : 'Roboto'};
font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
color: ${props => props.color ? props.color : '#323232'};
font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border-style: ${props => props.borderStyle ? props.borderStyle : 'none'};
background: ${props => props.background ? props.background : 'transparent'};
border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
width: ${props => props.width ? props.width : 'auto'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
outline: ${props => props.outline ? props.outline : 'none'}; 
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
max-width: 85%;
cursor: pointer;
&:focus {
    outline: none;
}
::placeholder {
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    color: ${props => props.phColor ? props.phColor : '#323232'};
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Roboto'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
}
`


const ClaroDivPesos = styled.div`
    text-align: center;
    font-size: ${props => props.fontSize ? props.fontSize : '1.5rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Nunito'};
    display: ${props => props.display ? props.display : 'none'};
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    font-weight: bold;
`


const ClaroInputButton = styled.button`
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    background: none; 
    border: none; 
    outline: none;
    color: "#000";
    font-size: 0.7rem;
    line-height: auto;
    vertical-align: middle;
    border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
    -webkit-appearance: none;
    border-radius: 0;
    display:table-cell;
`

class ClaroInput extends React.Component {

    constructor(props, context){
        super(props, context);
        this.state = {
            inputWidth: this.context.inputWidth,
            charsNumber:this.context.charsNumber,
            value:""
        }
    }

    static getDerivedStateFromProps(props, state) {
        let {input} = props
        if (input && (input.value !== state.value)) {
            // let interval = setInterval(() => {
            //     //autoPlay some for specific period of times or
            //     console.log(` #### lalala ${input.name}`)
            //     let autoChangeInput = document.getElementById(input.name); 
                
            //     if(autoChangeInput){

            //         console.log(` #### ${autoChangeInput.value}`)

            //         let event = new CustomEvent("onautochange", { "detail": autoChangeInput.value });
            //         //autoChangeInput.onChange()
            //         document.dispatchEvent(event);
            //     }
            //   }, 2000);
              
            console.log(` #### lalala ${input.name}`);

            let autoChangeInput = document.getElementById(input.name); 
            
            if(autoChangeInput){

                console.log(` #### ${autoChangeInput.value}`)

                let event = new CustomEvent("onautochange", { "detail": autoChangeInput.value });
                //autoChangeInput.onChange()
                document.dispatchEvent(event);
            }


            let objEvent = {
                ...input
            }
            
            input.onChange(objEvent)

            return {
                value:input.value
            };
        }

        return null;
      }

    onChangePesos = (event) =>{
        let { input:{onChange}, max : maxValue } = this.props
        
        const { getAmountFromOcrData, /*calculateInputWidth*/ } = this.context;
        
        let inputValue = event.target.value;

        let { maskedValue } = mask(inputValue, maxValue);

        getAmountFromOcrData(maskedValue);
        
        onChange(event)
    }

    onChange = (event) => {
        let { input:{onChange} } = this.props
        onChange(event)
        
    }
    
    onKeyUpHandle = (event) => {
        let itemFieldValueLenght = event.target.value.length;
        if(event.target.createTextRange) {
            var range = event.target.createTextRange();

            range.move('character', itemFieldValueLenght);
            range.select();
        } else {
            event.target.focus();
            event.target.setSelectionRange(itemFieldValueLenght, itemFieldValueLenght);
        }
    }
    
    assignId = (inputType) => {
        switch(inputType) {
            case "amount":
              return "monto";
            case "destAccountId":
              return "lineaCaptura";
            case "description":
                return "referencia";
            case "cvv":
            return "cvv";
            default:
              return "default";
          }
    }

    render(){

        let { fixedStyled, input, constraints, button } = this.props
        let styles = {}
        let stylesPesos = {}

        let validInvalidAmountColor =  '#000000'
        let validInvalidColor =  '#323232'
        let borderValidInvalidColor =  '1px solid #26012024'


        if(input.isValid === undefined || input.isValid === true){
            validInvalidAmountColor =  '#000000'
            validInvalidColor =  '#323232'
            borderValidInvalidColor =  '1px solid #26012024'

        }else{
            validInvalidAmountColor =  'red'
            validInvalidColor =  'red'
            borderValidInvalidColor =  '1px solid red'

        }
        
        let id = "pagoDeServicios_" + this.assignId(input.name) + "_" + this.props.serviceName;

        switch(fixedStyled){
            case 'amount':
                styles = {
                    "borderStyle": "none",
                    "background": "white",
                    "fontSize": "58px",
                    "line-height": "58px",
                    "textAlign": "right",
                    "borderBottom": `0px solid ${borderValidInvalidColor}`,
                    "color": `${validInvalidAmountColor}`,
                    "fontFamily":"NunitoBold",
                    "fontWeight": "bold",
                    "width":`${this.context.inputWidth}px`,
                    "height": "fit-content",
                    "phColor": "black",
                    "padding":"0rem"
                }
                stylesPesos = {
                    "fontFamily":"NunitoBold",
                    "fontSize": "58px", 
                    "display": "block",
                    "fontWeight": "bold"
                }

                let amount = this.context.ocrAmountValue;
               

                return(
                    <ClaroDiv  {...styles}>
                        <ClaroDivPesos {...stylesPesos}>
                            $
                        </ClaroDivPesos>
                        {
                            <ClaroInputFieldPesos 
                                {...input}
                                {...styles}
                                type="text"
                                pattern="[0-9]*"
                                constraints={constraints} 
                                value={this.context.ocrAmountValue}
                                onKeyUp={this.onKeyUpHandle}
                                id = {id}
                            />
                        }
                    </ClaroDiv>
                )

            default:{
                styles = {
                    "color": `${validInvalidColor}`,
                    "borderBottom": `${borderValidInvalidColor}`,
                }
                return(
                    <ClaroDiv  {...styles}>
                        <ClaroDivPesos {...stylesPesos}>
                        </ClaroDivPesos>
                        <ClaroInputField 
                            {...input} 
                            {...styles} 
                            constraints={constraints} 
                            value={this.state.value} 
                            onChange={this.onChange}
                            id = {id}
                        />
                        {
                            button ? (
                                <ClaroInputButton 
                                    borderBottom={borderValidInvalidColor} 
                                    {...button}
                                >
                                    <ClaroImage {...button} imageBoton={true}/>
                                </ClaroInputButton>
                            ):(<></>)
                        }
                    </ClaroDiv>
                )
            }
        } 
    }
}

ClaroInput.contextType = GenericFormContext;

export default ClaroInput;